<template>
  <div id="app_signup">
    <v-layout wrap>
      <v-flex xs12 md12 pa-8>
        <v-card id="app_height" outlined tile>
          <v-layout pt-12></v-layout>
          <v-layout pt-12></v-layout>
          <v-layout wrap pt-12 justify-center>
            <v-flex xs12 md2 align="center">
              <v-img src="../../assets/icons/tick.png" aspect-ratio="1" contain height="50px">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-center>
            <v-flex xs12 md12 text-center>
              <span style="font-size:18px;color:#000;font-weight:400">Session Expired</span>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-center>
            <v-flex xs12 md12 pt-3 text-center>
              <router-link to="/Login">
                <v-btn
                  width="220"
                  small
                  :ripple="false"
                  class="text-capitalize"
                  style="font-weight:300;"
                  color="#26af82"
                  dark
                >Login to Continue</v-btn>
              </router-link>
            </v-flex>
          </v-layout>
          <v-layout wrap justify-center>
            <v-flex xs12 md3 align="center">
              <v-img src="../../assets/person.png" contain height="300px">
                <template v-slot:placeholder>
                  <v-row class="fill-height ma-0" align="center" justify="center">
                    <v-progress-circular indeterminate color="#26af82"></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  beforeMount() {
    // this.submit();
  },
  methods: {
    submit() {
      setTimeout(() => {
        this.$router.push("/Login");
      }, 5000);
    }
  }
};
</script>
<style scoped>
#app_signup {
  background-image: url("../../assets/home_header.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: white;
}
@media only screen and (min-width: 800px) {
  #app_height {
    min-height: 80vh;
  }
}
</style>